import { Component } from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import { MedicoPanelItem } from './medicoPanelItem';

export class EquipoMedico extends Component {
  constructor() {
    super();
    this.state = {
      activeKey: 0,
      isActive: false,
      panelItems: '',
      countMedicos: '',
      currentPanelTitle: ''
    }

    this.handleSelectPanel = this.handleSelectPanel.bind(this);
  }

  handleSelectPanel(activeKey, isActive) {
   this.setState({ activeKey: activeKey, isActive: isActive, currentPanelTitle: isActive ? '-active' : '' });
  }

  parseResponse(data){
    const medicalTeam = data;
    if(medicalTeam.length > 0){
      this.setState({ countMedicos: medicalTeam.length, panelItems: medicalTeam.map(item => <MedicoPanelItem item={item} resetItemsTitle={(e) => this.resetItemsTitle(e) } configurations={this.props.configurations} />) })
    }
  }

  componentDidMount() {
      const validarInfo = new ServicioProxy('ConsultarRedAfiliadoEquipoMedico?tipoDocumento=' + this.props.userDocumentType + '&numeroDocumento=' + this.props.userDocument);  
      validarInfo.getElements('POST', {}).then((response) => {
        const data = JSON.parse(response);
        if(!data.Error){
          this.parseResponse(data.RedAfiliado); 
        }
      }).catch(error => console.error(error)); 
  }

  render() {
    return (
      <div className="content-mi-equipo-medico">
        
          <PanelGroup activeKey={this.state.activeKey} className="medical-equipment-container-panelgroup">  
            <Panel eventKey="1" className="medical-equipment-container-panel">
              <Panel.Heading onClick={()=> this.handleSelectPanel(1, !this.state.isActive)} className="medical-equipment-container-panel-heading">
                <Panel.Title toggle className="medical-equipment-container-panel-title">
                  <span className={ "mi-medico-title" + this.state.currentPanelTitle }>Mi Equipo Médico</span>

                  <div className="medicos-count">{ this.state.countMedicos }</div>
                  <div className={ 'accordion-icon ' + (this.state.activeKey === 1 ? 'active' : '' )}>
                    
                    <i className={ 'fa ' + ( this.state.isActive ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i>
                  </div>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible className="medical-equipment-container-panel-body">
                <div className='equipo-medico-contenido'></div>
                <span>{ this.props.configurations['MiEquipoMedicoTexto'] }</span>
                <div className="medicos-icon-list">
                  <i className={ 'fa fa-list-ul' }></i>
                </div>
                <div className="mi-medico-content-list">
                  { this.state.panelItems }
                </div>
              </Panel.Body>
            </Panel>
          </PanelGroup>
          
      </div>
   );
  }    
}
